import request from "@/utils/request";
import axios from 'axios';
import service from "@/utils/axios-v2";

const services = axios.create({
  baseURL: process.env.VUE_APP_IMAGE_UPLOAD,
  timeout: 30000,
})

export function uploadImage(image) {
  const formData = new FormData();
  formData.append("image", image);
  return services({
    url: "/tp/support/image",
    method: "post",
    data: formData,
    headers: {
      'Content-Typ': 'multipart/form-data',
    }
  });
}

export function getAppearance() {
  return request({
    url: "/fleet/query/appearance",
    headers: {
      "portal-token": true
    }
  });
}

export function changeAppearance(data) {
  return service({
    url: "/fleet/add/appearance",
    method: "post",
    data,
    headers: {
      "portal-token": true
    }
  });
}
